import { AlarmClock } from 'lucide-react';
import type { JSX } from 'react';

import styles from './ExpiryAlertChip.module.scss';
import type { TenantExpiryAlert } from '../api/tenants.graphql';
import { expiryAlertLabel, formatLifecycleDate } from '../tenant-labels';

const TONE: Record<TenantExpiryAlert['level'], string> = {
  NONE: styles.info ?? '',
  DAYS_7: styles.warn ?? '',
  DAYS_3: styles.warn ?? '',
  DAYS_1: styles.danger ?? '',
  EXPIRED: styles.danger ?? '',
};

/**
 * OS-1720 — cuenta regresiva del piloto. Sin alerta (más de 7 días) muestra la fecha de fin en
 * gris; con alerta, el texto ("Vence en 3 días", "Vencido hace 2 días") con color de urgencia
 * (el texto basta: el color no es la única señal). La fecha exacta va en `title`.
 */
export function ExpiryAlertChip({ alert }: { alert: TenantExpiryAlert }): JSX.Element {
  const date = formatLifecycleDate(alert.endsAt);
  const text = alert.level === 'NONE' ? `Termina el ${date}` : expiryAlertLabel(alert);
  return (
    <span
      className={`${styles.chip} ${TONE[alert.level]}`}
      title={`Fin del piloto: ${date}`}
    >
      <AlarmClock size={12} aria-hidden="true" />
      {text}
    </span>
  );
}
